import types from './types'

const updateRefreshCounter = () => ({
  type: types.POOLS_UPDATE_REFRESH_COUNTER
})

const resetRefreshCounter = () => ({
  type: types.POOLS_RESET_REFRESH_COUNTER
})

export default {
  updateRefreshCounter,
  resetRefreshCounter
}
